import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-retocuantrix',
  templateUrl: './modal-retocuantrix.component.html',
  styleUrls: ['./modal-retocuantrix.component.scss']
})
export class ModalRetocuantrixComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<ModalRetocuantrixComponent>) { }

  ngOnInit(): void {
  }
/**
   * Close dialog with lesson video
   */
 close() {
  this.dialogRef.close();
  }
  
  /**
   * Funcion para redireccionar al sitio
   */
  irSitio(): void{
    window.open('https://reto.cuantrix.mx/', "location=yes");
  }
}
